/*
 * Earn 3 · Trade 5 · Play 2 · Spend 4 · Build 2
 *
 * DERIVED, never typed out. The strip sits directly above the list it counts;
 * a hardcoded number is a claim that can silently contradict the thing
 * underneath it. Reconciling the two is one of the bugs this redesign exists
 * to fix — the previous signed-in screen said Trade 4 / Spend 3 while the
 * page above it said Trade 5 / Spend 4.
 */
import { byGroup, ZodiacProduct } from "../../data/zodiacProducts";
import s from "./landing.module.css";

export default function CountsStrip({ products }: { products: ZodiacProduct[] }) {
  return (
    <>
      <div className={s.rule} />
      <div className={s.counts}>
        {byGroup(products).map((g) => (
          <span key={g.id}>
            {g.label}&nbsp;&nbsp;<span className={s.countNum}>{g.items.length}</span>
          </span>
        ))}
      </div>
    </>
  );
}
